// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {startCase, map} from 'lodash';

// Styles
import './match-confidence-reason.scss';

class MatchConfidenceReason extends Component {
    renderContent() {
        const {items} = this.props;

        return map(items, (item, index) => <li key={index}>{startCase(item)}</li>);
    }

    render() {
        return (
            <section className="match-confidence-reason">
                <div className="match-confidence-reason--title">Score Basis</div>
                <ul className="match-confidence-reason--list">{this.renderContent()}</ul>
            </section>
        );
    }
}

MatchConfidenceReason.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MatchConfidenceReason;
